export default {
	PEDIDO: {
		VISUALIZAR: 'visualizar',
		EDITAR: 'editar',
	},
	SELECAO_ITEM_PEDIDO: {
		NOVO: 'novo',
		EDITAR: 'editar',
	},
}
